<template>
  <div :class="ns.e('value')">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { useNamespace } from '@bigin/hooks'

defineOptions({
  name: 'BDataValue',
})

const ns = useNamespace('form-item')
</script>
